import { render, staticRenderFns } from "./legacy-region.vue?vue&type=template&id=6def107a&"
import script from "./legacy-region.vue?vue&type=script&lang=js&"
export * from "./legacy-region.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports